<template>
  <div>
    <p style="text-align: center">
      <!-- {{this.$route.query}} -->
      <!-- 上课记录 -->
      <span class="systemFont1">{{ $t("p0331.classRecord") }}</span>
    </p>
    <el-row style="top: 17px">
      <!-- 模糊查询 -->
      <div style="display: inline-block;">
        <el-form
          :model="queryForm"
          label-position="right"
          ref="queryForm"
          label-width="80px"
          class="systemFont1"
        >
          <!-- 课程名称 -->
          <div style="width:400px;display: inline-block; float:left;">
            <el-form-item :label="$t('p0331.courseTitle')">
              <el-input
                name="queryForm.courseName"
                type="text"
                v-model="queryForm.courseName"
                clearable
                :placeholder="$t('p0331.courseTitle')"
              ></el-input>
            </el-form-item>
          </div>
          <div style="width:40px;display:inline-block; float:left;">
            &nbsp;&nbsp;
          </div>
          <!-- 上课时间 -->
          <div style="width:430px;display:inline-block; float:left;">
            <el-form-item :label="$t('p0331.classTime')">
              <el-date-picker
                v-model="queryForm.dateAndTime"
                type="daterange"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
          </div>
          <div
            style="width:70px;height:100%;display: inline-block; float:left;"
          >
            <img
              src="../../assets/query2.svg"
              width="36px"
              height="36px"
              style="cursor: pointer;"
              @click="init(true)"
            />
          </div>
        </el-form>
      </div>
      <el-col :span="22" :offset="1">
        <el-row><br /></el-row>
        <el-table
          :default-sort="{ prop: 'dateAndTime', order: 'descending' }"
          :data="courseData"
          v-loading="tableLoading"
          style="min-width: 1310px; margin-bottom: 30px"
        >
          <!-- 领域 -->
          <el-table-column
            prop="fieldValue"
            :label="$t('courseOption.field')"
            align="left"
            min-width="5"
          >
          </el-table-column>
          <!-- 类别 -->
          <el-table-column
            prop="categoryValue"
            :label="$t('p0331.category')"
            align="left"
            min-width="7"
          >
          </el-table-column>
          <!-- 编号 -->
          <el-table-column
            :formatter="valueFormat"
            :label="$t('p0331.numbering')"
            align="left"
            min-width="5"
          >
          </el-table-column>
          <!-- 形式 -->
          <el-table-column
            prop="form"
            :label="$t('courseOption.form')"
            align="left"
            min-width="5"
          >
          </el-table-column>
          <!-- 课程名称 -->
          <el-table-column
            prop="courseName"
            :label="$t('p0331.courseTitle')"
            align="left"
            min-width="12"
          >
          </el-table-column>
          <!-- 上课时间 -->
          <el-table-column
            prop="dateAndTime"
            :formatter="dateAndTimeFormat"
            :label="$t('p0331.classTime')"
            align="left"
            min-width="10"
          >
          </el-table-column>
          <!-- 老师 -->
          <el-table-column
            prop="teachers"
            :label="$t('p0331.teacher')"
            align="left"
            min-width="5"
          >
            <template slot-scope="scope">
              <el-row v-if="scope.row.teachers != null">
                <span
                  v-for="(item, index) in scope.row.teachers.split(',')"
                  :key="index"
                  style="white-space: pre-wrap;"
                  >{{ item }}</span
                >
              </el-row>
            </template>
          </el-table-column>
          <!-- 报名人数 -->
          <el-table-column
            prop="numberOfApplicants"
            :label="$t('p0331.numberOfApplicants')"
            align="center"
            min-width="5"
            :formatter="numberOfApplicantsForMatter"
          >
          </el-table-column>
          <!-- 上课人数 -->
          <el-table-column
            prop="numberOfStudentsInClass"
            :label="$t('p0331.numberOfStudentsInClass')"
            align="center"
            min-width="5"
            :formatter="numberOfStudentsInClassForMatter"
          >
          </el-table-column>
          <!-- 单价 -->
          <el-table-column
            :label="$t('p0331.unitPrice')"
            align="right"
            header-align="right"
            min-width="5"
            :formatter="formatPrice"
          >
          </el-table-column>
          <!-- 总收费 -->
          <el-table-column
            :label="$t('p0331.totalCharge')"
            align="right"
            min-width="5"
            prop="totalCharge"
          >
          </el-table-column>
          <!-- 货币 -->
          <el-table-column
            prop="currency"
            :label="$t('p0331.currency')"
            align="center"
            min-width="4"
          >
          </el-table-column>
          <!-- 通过率 -->
          <el-table-column
            :label="$t('p0331.passingRate')"
            align="center"
            min-width="4"
          >
          </el-table-column>
          <!-- 操作 -->
          <el-table-column :label="$t('p0331.operate')" min-width="3">
            <!-- 详情 -->
            <template slot-scope="scope">
              <el-button type="text" @click="detailsClick(scope.row)">{{
                $t("p0331.details")
              }}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-row style="text-align: right; margin: 20px">
          <el-col :span="24">
            <div class="block">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPageCo"
                :page-sizes="[10, 20, 50]"
                :page-size="pageSizeCo"
                layout="total, sizes, prev, pager, next"
                :total="totalCo"
              >
              </el-pagination>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      // 查询条件
      queryForm: {
        courseName: "",
        dateAndTime: ""
      },
      // 当前页
      currentPageCo: 1,
      // 每页件数
      pageSizeCo: 10,
      totalCo: 0,
      // 课程数据
      courseData: [],
      // 表格加载
      tableLoading: false
    };
  },
  watch: {
    // 监听上课时间区段
    "queryForm.dateAndTime"(newVal) {
      if (newVal == null) {
        this.queryForm.dateAndTime = [];
        this.init(true);
      }
    },
    // 监听课程名称是否为空
    "queryForm.courseName"(newVal) {
      if (newVal == "") {
        this.queryForm.courseName = "";
        this.init(true);
      }
    }
  },
  methods: {
    // 每页数据条数设定
    handleSizeChange(val) {
      this.pageSizeCo = val;
      this.currentPageCo = 1;
      //判断更改页码是否需要查询
      if (this.courseData == undefined || this.courseData.length <= 0) {
        return;
      }
      this.init(false);
      // console.log(`每页 ${val} 条`);
    },
    // 当前页显示
    handleCurrentChange(val) {
      this.currentPageCo = val;
      this.init(false);
      // console.log(`当前页: ${val}`);
    },
    //详情
    detailsClick(row) {
      let p0332 = JSON.stringify({
        field: row.field,
        category: row.category,
        courseName: row.courseName,
        courseNumber: row.courseNumber,
        dateAndTime: moment(row.dateAndTime).format("YYYY-MM-DD HH:mm:ss"),
        endDateAndTime: moment(row.endDateAndTime).format("YYYY-MM-DD HH:mm:ss"),
        formCode: row.formCode,
        courseType: row.courseType,
      });
      sessionStorage.p0332 = p0332;
      this.$router.push({
        path: "/views/GreenJacketForum/P0332",
        query: {
          dateAndTime: this.queryForm.dateAndTime,
          courseName: this.queryForm.courseName,
          currentPageCo: this.currentPageCo,
          totalCo: this.totalCo,
          pageSizeCo: this.pageSizeCo
        }
      });
    },
    //格式化时间
    dateAndTimeFormat(row) {
      if (row.formCode == "02") {
        return this.$t("p0322.unlimited");
      } else {
        return moment(row.dateAndTime).format("YYYY-MM-DD HH:mm");
      }
    },
    // 初始化课程数据
    init(val) {
      if (val) {
        // 分页数据初始化
        this.currentPageCo = 1;
        this.totalCo = 0;
      }
      this.tableLoading = true;
      let url = "/api/classRecord/selectClassRecord";
      this.$http
        .post(url, {
          //课程名称模糊查询
          selectCourseName: this.queryForm.courseName,
          // 开始日期
          startDate: this.queryForm.dateAndTime[0],
          // 截止日期
          endDate: this.queryForm.dateAndTime[1],
          // 当前页
          currentSizeCo: (this.currentPageCo - 1) * this.pageSizeCo,
          // 页数
          pageSizeCo: this.pageSizeCo,
          // 总数
          totalCo: this.totalCo
        })
        .then(response => {
          if (response.data.code === 200) {
            this.tableLoading = false;
            // 判断有没有数据
            if (response.data.data == null) {
              this.courseData = [];
            } else {
              // 总数取值
              this.totalCo = response.data.data[0].totalCo;
              // 渲染页面
              this.courseData = response.data.data;
              // 遍历老师数组
              for (let i = 0; i < response.data.data.length; i++) {
                if (this.courseData[i].teachers != null) {
                  var teacherStr = this.courseData[i].teachers.split(",");
                  // console.log("teacherStrh",teacherStr)
                  // console.log("teacherStr.length",teacherStr.length)
                  let str = "";
                  for (let j = 0; j < teacherStr.length; j++) {
                    str = str + teacherStr[j] + ",\n";
                  }
                  this.courseData[i].teachers = str;
                }
              }
            }
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          this.tableLoading = false;
          this.$message.error(err);
        });
    },
    /* 数字金额逢三加， 比如 123,464.23 */
    //单价
    unitPriceForMatter(row, column) {
      return row.unitPrice.toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
    },
    //上课人数
    numberOfStudentsInClassForMatter(row, column) {
      return row.numberOfStudentsInClass
        .toString()
        .replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
    },
    //报名人数
    numberOfApplicantsForMatter(row, column) {
      return row.numberOfApplicants
        .toString()
        .replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
    },
    // 课程编号拼接
    valueFormat(row) {
      return row.field + row.category + row.courseNumber;
    },
    // 货币格式
    formatPrice(row) {
      console.log("row", row);
      var price = "";
      if (row.unitPrice != "" && row.unitPrice != null) {
        price = row.unitPrice.toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
        if (price.includes(".")) {
          price = price.split(".")[1].length < 2 ? price + "0" : price;
        } else {
          price += ".00";
        }
        return price;
      }
    },
    formatSumPrice(row) {
      var price = "";
      if (row.unitPrice != "" && row.unitPrice != null) {
        let discountSum = 0;
        // 有使用优惠码的人
        if (row.useCouponCodeNo != null && row.useCouponCodeNo != "") {
          // 指定人优惠金额
          var personDiscountNo = row.personDiscount.split(",");
          // 使用优惠码人数
          var personNo = row.useCouponCodeNo.split(",");
          for (let j = 0; j < personDiscountNo.length; j++) {
            if (personDiscountNo[j] == "NA") {
              // 没有指定人优惠
              if (!row.limitDiscount && !row.defaultDiscount) {
                // 没有优惠
                discountSum = discountSum;
              } else if (!row.limitDiscount && row.defaultDiscount) {
                // 只有默认优惠
                discountSum =
                  discountSum + row.defaultDiscount * 1 * (personNo[j] * 1);
              } else if (row.limitDiscount) {
                // 有限时优惠
                discountSum =
                  discountSum + row.limitDiscount * 1 * (personNo[j] * 1);
              }
            } else {
              // 有指定人优惠
              if (!row.limitDiscount) {
                // 没有限时优惠
                discountSum =
                  discountSum + personDiscountNo[j] * 1 * (personNo[j] * 1);
              } else if (row.limitDiscount) {
                // 有限时优惠
                if (personDiscountNo[j] > row.limitDiscount) {
                  // 指定人优惠大于限时优惠
                  discountSum =
                    discountSum + personDiscountNo[j] * 1 * (personNo[j] * 1);
                } else {
                  // 指定人优惠小于等于限时优惠
                  discountSum =
                    discountSum + row.limitDiscount * 1 * (personNo[j] * 1);
                }
              }
            }
          }
        }
        var sumPrice = (
          row.unitPrice * 1 * row.numberOfApplicants -
          discountSum
        ).toFixed(2);
        if (sumPrice * 1 > 0) {
          price = sumPrice.toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
          if (price.includes(".")) {
            price = price.split(".")[1].length < 2 ? price + "0" : price;
          } else {
            price += ".00";
          }
          return price;
        } else {
          price = "0.00";
          return price;
        }
      }
    }
  },
  mounted() {
    if (this.$route.query.currentPageCo) {
      this.currentPageCo = Number(this.$route.query.currentPageCo);
    }
    if (this.$route.query.totalCo) {
      this.totalCo = Number(this.$route.query.totalCo);
    }
    if (this.$route.query.pageSizeCo) {
      this.pageSizeCo = Number(this.$route.query.pageSizeCo);
    }
    if (this.$route.query.courseName) {
      this.queryForm.courseName = this.$route.query.courseName;
    }
    if (this.$route.query.dateAndTime) {
      this.queryForm.dateAndTime = this.$route.query.dateAndTime;
    }
    let path = this.$route.path; //先获取路由路径
    this.$router.replace(path); //再跳转路由路径，query参数没带过去，所以被清除了
    this.init(false);
  }
};
</script>

<style lang="scss" scoped>
>>> .el-table thead {
  font-family: "Arial Negreta", "Arial Normal", "Arial";
  color: #333333;
  font-size: 16px;
}

>>> .el-table__header {
  border-bottom: 3px solid rgb(170, 170, 170);
}

>>> .el-table__row {
  height: 42px;
}

>>> .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  border-bottom: 0.5px solid rgb(170, 170, 170);
}

>>> .el-table--border::after,
.el-table--group::after,
.el-table::before {
  background: none;
}
</style>



// WEBPACK FOOTER //
// src/views/GreenJacketForum/P0331.vue